import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearOAuthSession } from '../../../auth/oauth';
import { logout, type AdminProfile } from '../../../features/session/sessionSlice';
import type { AppDispatch, RootState } from '../../App/store';

export default function TopbarProfile() {
  const dispatch = useDispatch<AppDispatch>();
  const user = useSelector((state: RootState) => state.user.user) as AdminProfile;
  const handleLogout = () => {
    clearOAuthSession();
    dispatch(logout());
  };

  return (
    <div className="topbar__profile">
      <button type="button" className="topbar__avatar" onClick={handleLogout} title="로그아웃">
        <img
          className="topbar__avatar-img"
          src="https://cdn.kkutu.io/img/bi/bi_profile_white.png"
          alt=""
        />
        <p className="topbar__avatar-name"><b>{user.team}</b> {user.name}</p>
      </button>
    </div>
  );
}
